import React, { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLoading } from '../Utils/LoadingContext';
import EmployeeProcessService from '../services/EmployeeProcessService';
import LeaveProcessService from '../services/LeaveProcessService';
import EmployeeAttendance from './EmployeeAttendance';
import './EmployeeProfile.css';
import { useNavigate } from "react-router-dom";

const TAB_LIST = [
    { key: 'personalInfo', label: 'Personal Info' },
    { key: 'officialInfo', label: 'Official Info' },
    { key: 'documents', label: 'Documents' },
    { key: 'reportingStructure', label: 'Reporting Structure' },
    { key: 'attendance', label: 'Attendance' },
    { key: 'leaveHistory', label: 'Leave History' },
    { key: 'bankDetails', label: 'Bank Details' },
    { key: 'emergencyContact', label: 'Emergency Contact' },
    { key: 'education', label: 'Education' },
    { key: 'experience', label: 'Experience' },
    { key: 'timeline', label: 'Timeline' }
];

const EMPTY_PROFILE = {
    employeeId: 'N/A',
    employeeName: 'Employee',
    designation: 'N/A',
    department: 'N/A',
    joiningDate: null,
    status: 'Active',
    role: 'Employee',
    phone: 'N/A',
    email: 'N/A',
    location: 'N/A',
    initials: 'EM'
};

const callFirstAvailable = async (service, methods, ...args) => {
    for (const methodName of methods) {
        const fn = service?.[methodName];
        if (typeof fn === 'function') {
            return await fn(...args);
        }
    }
    return null;
};

const getResultArray = (response) => {
    if (!response) return [];
    const data = response?.data?.result ?? response?.data ?? response?.result ?? response;
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.items)) return data.items;
    if (data && typeof data === 'object') return [data];
    return [];
};

const normalizeProfile = (raw, employeeCode, employeeName) => {
    debugger;
    const name =
        raw?.employeeName ||
        raw?.fullName ||
        raw?.empName ||
        employeeName ||
        'Employee';

    const dept = raw?.departmentName || raw?.department || 'N/A';
    const designation = raw?.designationName || raw?.designation || raw?.jobTitle || 'N/A';
    const employeeId = raw?.employeeCode || raw?.employeeId || raw?.empCode || employeeCode || 'N/A';
    const joiningDate = raw?.joiningDate || raw?.dateOfJoining || raw?.doj || null;

    return {
        employeeId,
        employeeName: name,
        designation,
        department: dept,
        joiningDate,
        status: raw?.status || 'Active',
        role: raw?.employeeType || raw?.role || 'Employee',
        phone: raw?.phone || raw?.mobileNo || raw?.contactNumber || 'N/A',
        email: raw?.email || raw?.emailId || 'N/A',
        location: raw?.plantName || raw?.location || raw?.officeLocation || 'N/A',
        initials: name
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((x) => x[0]?.toUpperCase())
            .join('') || 'EM'
    };
};

const InfoGrid = ({ items }) => (
    <div className="profile-info-grid">
        {items.map((item) => (
            <div className="profile-info-item" key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value || 'N/A'}</strong>
            </div>
        ))}
    </div>
);

const TableSection = ({ rows, columns, emptyText = 'No data found.' }) => {
    if (!rows?.length) {
        return <div className="profile-empty-state">{emptyText}</div>;
    }

    return (
        <div className="table-responsive">
            <table className="table profile-table align-middle mb-0">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.key}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={row.id || row.documentId || row.code || index}>
                            {columns.map((col) => (
                                <td key={col.key}>{row[col.key] ?? 'N/A'}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const EmployeeProfile = () => {
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const employeeName = localStorage.getItem('username') || 'User';
    const employeeCode = localStorage.getItem('empcode') || '0';
    const [leaveBalance, setLeaveBalance] = useState([]);
    const [activeTab, setActiveTab] = useState('personalInfo');
    const [profile, setProfile] = useState({ ...EMPTY_PROFILE, employeeId: employeeCode, employeeName });
    const [tabData, setTabData] = useState({});

    const summaryCards = [
        {
            label: "Employee ID",
            value: profile.employeeCode
        },
        {
            label: "Joining Date",
            value: profile.doj
                ? dayjs(profile.doj).format("DD MMM YYYY")
                : "N/A"
        },
        {
            label: "Department",
            value: profile.departmentName
        }
    ];
    const loadProfileSummary = async () => {
        try {
            setLoading(true);
            // const formData = new FormData();
            // formData.append("EmployeeCode", employeeCode);

            const response = await EmployeeProcessService.getEmployeeProfile(employeeCode);
            console.log(response);
            if (
                response?.data?.statusCode === 200 &&
                response.data.result?.length > 0
            ) {
                const emp = response.data.result[0];

                setProfile(emp);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };
    const today = new Date();
    const [month, setMonth] = useState(
        `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
    );
    const getLeaveMMYY = () => {
        const [year, monthPart] = month.split("-");
        return `${monthPart}${year}`;
    };
    const loadLeaveBalance = async () => {
        try {
            const formData = new FormData();

            formData.append("EmployeeCode", employeeCode);
            formData.append("Type", "GetLeave");
            formData.append("LeaveMMYY", getLeaveMMYY());

            const res = await LeaveProcessService.getEmployeeDashBoard(formData);
            debugger;
            console.log(res)
            if (res.data.statusCode === 200) {

                setLeaveBalance(
                    res.data.result.map(x => ({
                        leaveCode: x.leaveCode,
                        totalBalance: x.availableBalance
                    }))
                );
                console.log('Govind' + leaveBalance)
            }
        }
        catch (error) {
            const message = error?.message || 'Unexpected error occurred.';
            // toast.error(message);
            console.error("Unhandled error:", message);
            setLoading(false);
        } finally {
            setLoading(false);
        }

    };
    const tabMethodMap = useMemo(
        () => ({
            personalInfo: ['getEmployeePersonalInfo', 'getEmployeePersonalDetails'],
            officialInfo: ['getEmployeeOfficialInfo', 'getEmployeeOfficialDetails'],
            documents: ['getEmployeeDocuments', 'getEmployeeDocumentList'],
            reportingStructure: ['getEmployeeReportingStructure', 'getEmployeeHierarchy'],
            leaveHistory: ['getEmployeeLeaveHistory', 'getEmployeeLeaveList'],
            bankDetails: ['getEmployeeBankDetails', 'getEmployeeBankInfo'],
            emergencyContact: ['getEmployeeEmergencyContact', 'getEmployeeEmergencyContacts'],
            education: ['getEmployeeEducation', 'getEmployeeEducationDetails'],
            experience: ['getEmployeeExperience', 'getEmployeeExperienceDetails'],
            timeline: ['getEmployeeTimeline', 'getEmployeeActivityTimeline']
        }),
        []
    );



    const loadTabData = async (tabKey) => {
        if (tabKey === 'attendance') return;

        const existing = tabData[tabKey];
        if (existing?.loaded) return;

        let response = null;
        if (tabKey === 'leaveHistory') {
            // loadLeaveBalance();
        }

        else {
            response = await callFirstAvailable(
                EmployeeProcessService,
                tabMethodMap[tabKey] || [],
                employeeCode
            );
        }

        const result = getResultArray(response);
        setTabData((prev) => ({
            ...prev,
            [tabKey]: {
                loaded: true,
                rows: result
            }
        }));
    };

    useEffect(() => {
        const init = async () => {
            try {
                setLoading(true);
                await loadProfileSummary();
                await loadTabData(activeTab);
            } finally {
                setLoading(false);
            }
        };

        if (employeeCode && employeeCode !== '0') {
            init();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employeeCode]);

    useEffect(() => {
        if (activeTab === "leaveHistory") {
            loadLeaveBalance();
        }
    }, [activeTab]);

    useEffect(() => {
        const loadCurrentTab = async () => {
            try {
                setLoading(true);
                await loadTabData(activeTab);
            } finally {
                setLoading(false);
            }
        };

        loadCurrentTab();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    const currentRows = tabData[activeTab]?.rows || [];

    const renderTabContent = () => {
        switch (activeTab) {
            case 'personalInfo':
                return (
                    <InfoGrid
                        items={[
                            { label: "Employee Name", value: profile.employeeName },
                            { label: "Father Name", value: profile.fatherName },
                            { label: "DOB", value: profile.dob },
                            { label: "Gender", value: profile.gender },
                            { label: "Mobile", value: profile.mobile },
                            { label: "Marital Status", value: profile.maritalStatus },
                            { label: "Address", value: profile.permanentAddress },
                            { label: "Aadhar", value: profile.aadharNo },
                            { label: "PAN", value: profile.PANNumber }
                        ]}
                    />
                );

            case 'officialInfo':
                return (
                    <InfoGrid
                        items={[
                            { label: "Employee Code", value: profile.employeeCode },
                            { label: "Company", value: profile.companyName },
                            { label: "Plant", value: profile.plantName },
                            { label: "Vendor", value: profile.venderName },
                            { label: "Department", value: profile.departmentName },
                            { label: "Sub Department", value: profile.subDepartmentName },
                            { label: "Designation", value: profile.designationName },
                            { label: "Grade", value: profile.gradeName },
                            { label: "Location", value: profile.locationName },
                            { label: "Shift", value: profile.shiftName },
                            { label: "Week Off", value: profile.weekOffID },
                            { label: "Joining Date", value: profile.doj },
                            { label: "Status", value: profile.employeeStatus },
                            { label: "Type", value: profile.type }
                        ]}
                    />
                );

            case 'documents':
                return (
                    <TableSection
                        rows={currentRows}
                        columns={[
                            { key: 'documentName', label: 'Document Name' },
                            { key: 'documentType', label: 'Type' },
                            { key: 'status', label: 'Status' }
                        ]}
                        emptyText="No documents uploaded."
                    />
                );

            case 'reportingStructure':
                return (
                   <InfoGrid
            items={[
                { label: "Manager Code", value: profile.managerCode },
                { label: "Manager Name", value: profile.managerName }
            ]}
        />
                );

            case 'attendance':
                return (
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h5>Attendance</h5>
                            <button
                                className="link-btn"
                                onClick={() => navigate("/EmployeeAttendance")}
                            >
                                View
                            </button>
                        </div>

                        <div className="text-center p-5">
                            Click View to open Attendance Dashboard
                        </div>
                    </div>
                );

            case 'leaveHistory':
                return (
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h5>My Leave Balance</h5>

                            <button
                                className="link-btn"
                                onClick={() => navigate("/LeaveApply")}
                            >
                                Apply
                            </button>
                        </div>

                        {leaveBalance.length > 0 ? (
                            leaveBalance.map((item, index) => (
                                <div className="leave-item" key={index}>
                                    <div className="leave-row">
                                        <span>{item.leaveCode}</span>
                                        <span>{item.totalBalance} left</span>
                                    </div>

                                    <div className="progress">
                                        <div
                                            className="progress-fill"
                                            style={{
                                                width: `${Math.min(item.totalBalance * 10, 100)}%`
                                            }}
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-4">
                                No leave balance found.
                            </div>
                        )}
                    </div>
                );

            case 'bankDetails':
                return (
                    <InfoGrid
                        items={[
                            { label: "Bank Name", value: profile.bankName },
                            { label: "Account No", value: profile.bankAccountNo },
                            { label: "IFSC", value: profile.IFSCCode },
                            { label: "PF Number", value: profile.PFNumber },
                            { label: "ESIC Number", value: profile.ESICNumber }
                        ]}
                    />
                );

            case 'emergencyContact':
                return currentRows?.length ? (
                    <TableSection
                        rows={currentRows}
                        columns={[
                            { key: 'contactName', label: 'Contact Name' },
                            { key: 'relation', label: 'Relation' },
                            { key: 'phone', label: 'Phone' }
                        ]}
                        emptyText="No emergency contact added."
                    />
                ) : (
                    <div className="profile-alert-box">
                        <span className="profile-alert-icon">⚠</span>
                        <span>No emergency contact added</span>
                    </div>
                );

            case 'education':
                return (
                    <InfoGrid
                        items={[
                            {
                                label: "Qualification",
                                value: profile.qualificationName
                            }
                        ]}
                    />
                );

            case 'experience':
                return (
                    <TableSection
                        rows={currentRows}
                        columns={[
                            { key: 'companyName', label: 'Company' },
                            { key: 'designation', label: 'Designation' },
                            { key: 'duration', label: 'Duration' }
                        ]}
                        emptyText="No experience records found."
                    />
                );

            case 'timeline':
                return currentRows?.length ? (
                    <div className="profile-timeline">
                        {currentRows.map((item, index) => (
                            <div className="profile-timeline-item" key={item.id || index}>
                                <div className="profile-timeline-dot"></div>
                                <div>
                                    <strong>{item.title || item.eventName || 'Timeline Event'}</strong>
                                    <div className="text-muted small">{item.date || item.createdOn || 'N/A'}</div>
                                    <p className="mb-0 mt-1">{item.description || item.remarks || 'No details available.'}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="profile-empty-state">No timeline records found.</div>
                );

            default:
                return <div className="profile-empty-state">No data found.</div>;
        }
    };

    return (
        <div className="employee-profile-page">
            <div className="profile-breadcrumb">Home &gt; Employees &gt; {profile.employeeName}</div>
            <h2 className="profile-page-heading">Employee Profile</h2>

            <div className="profile-hero-card">
                <div className="profile-banner"></div>

                <div className="profile-avatar-wrap">
                    <div className="profile-avatar">
                        {profile.employeeName
                            ?.trim()
                            .split(" ")
                            .filter(Boolean)
                            .map(name => name.charAt(0).toUpperCase())
                            .filter((_, index, arr) => index === 0 || index === arr.length - 1)
                            .join("")}
                    </div>
                    <span className="profile-status-dot"></span>
                </div>

                <div className="profile-header-body">
                    <div className="profile-basic-info">
                        <div className="profile-name-row">
                            <h3>{profile.employeeName}</h3>
                            <span className="profile-pill success">{profile.employeeStatus}</span>
                            <span className="profile-pill neutral">{profile.gradeName}</span>
                        </div>

                        <div className="profile-subtitle">
                            {profile.designation} • {profile.department}
                        </div>

                        <div className="profile-contact-row">
                            <span>📞 {profile.pmobilehone}</span>
                            <span>✉ {profile.email}</span>
                            <span>📍 {profile.locationName}</span>
                        </div>
                    </div>

                    <div className="profile-summary-cards">
                        {summaryCards.map((item) => (
                            <div className="profile-summary-card" key={item.label}>
                                <span>{item.label}</span>
                                <strong>{item.value}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="profile-tabs-card">
                <div className="profile-tabs-scroll">
                    {TAB_LIST.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            className={`profile-tab-btn ${activeTab === tab.key ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.key)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="profile-tab-content">{renderTabContent()}</div>
            </div>
        </div>
    );
};

export default EmployeeProfile;
